/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_MakeInputs */

const en_us2_invite_make = /** @type {(inputs: Invite_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Make my invite`)
};

const pt_br2_invite_make = /** @type {(inputs: Invite_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar meu convite`)
};

const pt_pt2_invite_make = /** @type {(inputs: Invite_MakeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar meu convite`)
};

/** @type {(inputs: Invite_MakeInputs) => LocalizedString} */
const es_419_invite_make = en_us2_invite_make;

/** @type {(inputs: Invite_MakeInputs) => LocalizedString} */
const fr_fr2_invite_make = en_us2_invite_make;

/** @type {(inputs: Invite_MakeInputs) => LocalizedString} */
const de_de2_invite_make = en_us2_invite_make;

/** @type {(inputs: Invite_MakeInputs) => LocalizedString} */
const it_it2_invite_make = en_us2_invite_make;

/**
* | output |
* | --- |
* | "Make my invite" |
*
* @param {Invite_MakeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const invite_make = /** @type {((inputs?: Invite_MakeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_MakeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_invite_make(inputs)
	if (locale === "es-419") return es_419_invite_make(inputs)
	if (locale === "pt-PT") return pt_pt2_invite_make(inputs)
	if (locale === "fr-FR") return fr_fr2_invite_make(inputs)
	if (locale === "de-DE") return de_de2_invite_make(inputs)
	if (locale === "it-IT") return it_it2_invite_make(inputs)
	return en_us2_invite_make(inputs)
});
export { invite_make as "invite.make" }